import { useMemo } from 'react';

import { type TypeSelectOption } from '@thefarmersfront/kitchen';

import { Table, TableBottomField, TableTopField } from '~/components/common';

import { getClaimExchangeItemsAddColumnDefs } from '~/utils';

import { PRODUCT_PAGE_SIZE } from '~/constants';

import type { TypeExchangeItemAddData } from '~/types/claim.types';
import type { TypePagination } from '~/types/common.types';

import styles from '../ClaimExchangeItemAddModal.module.scss';

const ClaimExchangeItemAddTable = ({
  data,
  pagination,
  onChangeRowSelection,
  onChangePageLimit,
  onChangePage,
}: {
  data: TypeExchangeItemAddData[] | null;
  pagination: TypePagination;
  onChangeRowSelection: (selectedRows: TypeExchangeItemAddData[]) => void;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onChangePage: (value: number) => void;
}) => {
  const { columnDefs } = useMemo(() => getClaimExchangeItemsAddColumnDefs(), []);

  return (
    <div>
      <TableTopField dataTotalCount={pagination.totalCount} />
      <div className={styles['table-wrapper']}>
        <Table
          data={data}
          columns={columnDefs}
          rowStatusType={data === null ? 'INIT' : 'EMPTY'}
          selection={{ onChange: onChangeRowSelection }}
        />
      </div>
      <TableBottomField
        pageSizeOptions={Object.values(PRODUCT_PAGE_SIZE)}
        currentPage={pagination.currentPage}
        totalCount={pagination.totalCount}
        pageSize={pagination.pageSize}
        onChangePageLimit={onChangePageLimit}
        onClickPage={onChangePage}
      />
    </div>
  );
};

export default ClaimExchangeItemAddTable;
